import React from 'react';

import {BrowsePageContent, CertificationTopic, PaginatedContent} from '@udemy/browse-aggregator';
import {useI18n} from '@udemy/i18n';
import {CertificationExamCarousel, VoucherUIRegion} from '@udemy/react-certification-preparation';
import {CourseSearchQuery} from '@udemy/react-discovery-units';
import {useFeatures} from '@udemy/react-experimentation-provider';

import {CertificationAggregatorCourseDirectory} from '../../components/aggregator-course-directory/certification-aggregator-course-directory.react-component';
import {CERT_VOUCHERS_SHOW_ADD_TO_CART} from '../../lib/experimentation-constants';
import styles from './certification-preparation.module.less';
import {
    AggregatorHeroWrapper,
    CERTIFICATION_PREPARATION_TITLE,
} from './components/aggregator-hero-wrapper/aggregator-hero-wrapper';
import {
    IssuerCertificationAggregatorCarouselWrapper,
    SubjectCertificationAggregatorCarouselWrapper,
} from './components/certification-aggregator-carousel-wrapper/certification-aggregator-carousel-wrapper.react-component';
import {CertificationPrepFaq} from './components/certification-prep-faq/certification-prep-faq.react-component';
import {CertificationTopicCarouselWrapper} from './components/certification-topic-carousel-wrapper/certification-topic-carousel-wrapper.react-component';

export const CARD_CAROUSEL_PAGE_SIZE = 24;
export const MAX_CARDS_ON_STACKED_VIEW = 16;

export type CertificationPreparationProps = {
    issuerAggregatorsComponentInitialData: PaginatedContent<BrowsePageContent>;
    subjectAggregatorsComponentInitialData: PaginatedContent<BrowsePageContent>;
    certificationTopicCarouselComponentInitialData: PaginatedContent<CertificationTopic>;
    courseSearchInitialData?: CourseSearchQuery;
};

export function CertificationPreparation(props: CertificationPreparationProps) {
    const {gettext} = useI18n();
    const {featureVariantAssignments} = useFeatures([CERT_VOUCHERS_SHOW_ADD_TO_CART]);

    const certVouchersFeature = featureVariantAssignments.get(CERT_VOUCHERS_SHOW_ADD_TO_CART);
    const certVouchersShowAddToCartButton =
        certVouchersFeature?.configuration?.certVouchersShowAddToCart ?? false;

    return (
        <div data-testid={'certification-preparation'}>
            <section className={styles['fill-background']}>
                <div className={styles['aggregator-hero-banner']}>
                    <AggregatorHeroWrapper />
                </div>
            </section>
            <section className={styles['ud-container-with-common-padding--only-top']}>
                <IssuerCertificationAggregatorCarouselWrapper
                    initialData={props.issuerAggregatorsComponentInitialData}
                />
            </section>
            <section className={styles['ud-container-with-common-padding--only-top']}>
                <SubjectCertificationAggregatorCarouselWrapper
                    initialData={props.subjectAggregatorsComponentInitialData}
                />
            </section>

            <section className={styles['ud-container-with-common-padding--only-top']}>
                {/*  */}
                <CertificationExamCarousel
                    uiRegion={'voucher_landing' as VoucherUIRegion}
                    title={gettext('Exam vouchers')}
                    subtitle={gettext(
                        'Buy your exam voucher with Udemy and get certified for less',
                    )}
                    variant="dark"
                    showQuickViewBox={certVouchersShowAddToCartButton}
                    experimentFeature={certVouchersFeature}
                />
            </section>

            <section className={styles['ud-container-with-common-padding']}>
                <CertificationTopicCarouselWrapper
                    initialData={props.certificationTopicCarouselComponentInitialData}
                />
            </section>
            <section className={styles['ud-container-with-common-padding--only-top']}>
                <CertificationAggregatorCourseDirectory
                    title={CERTIFICATION_PREPARATION_TITLE(gettext)}
                />
            </section>
            <section className={styles['fill-background']}>
                <div className={styles['faq']}>
                    <CertificationPrepFaq />
                </div>
            </section>
        </div>
    );
}
